<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card title="Book/Title Analysis Categories">


    <div class="vx-row mb-2 pt-2">
      <div class="vx-col w-full">

        <vs-collapse type="border" class="mb-2" accordian>

          <vs-collapse-item
            v-for="analysis in allAnalyses"
            :key="analysis.id">
            <div slot="header">
              {{safeCall(analysis.cyclopedia,'name', '')}}: ({{ helpers.cyclopediaAnalysis.getPreferredName(analysis) }})
            </div>

            <div class="vx-row no-gutter">
              <div class="p-1 vx-col">
                <cyclopedia-analysis-categories-editor
                  :key="analysis.id"
                  :product="new types.Product(product)"
                  :language="new types.Language(language)"
                  :analysis="new types.CyclopediaAnalysis(analysis)" >
                </cyclopedia-analysis-categories-editor>
              </div>
            </div>

          </vs-collapse-item>

        </vs-collapse>





      </div>
    </div>



<!--    <div class="vx-row">-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full">Save Changes</vs-button></div>-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full" color="warning" type="border" @click="revert">Cancel</vs-button></div>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
  import types from '@/models';
  import helpers from '@/models/helpers';
  import CyclopediaAnalysisCategoriesEditor from './cyclopediaCategories/CyclopediaAnalysisCategoriesEditor';

  export default {
    components: {
      CyclopediaAnalysisCategoriesEditor,
    },
    data() {
      return {
        types: types,
        helpers: helpers,
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true,
      },
      cyclopedias: {
        type: Array,
        required: true,
      },
      language: {
        type: types.Language,
        required: true,
      },
    },
    // beforeUpdate() {
    //   if (this.currentCyclopediaId !== null || this.cyclopedias.length === 0) return;
    //   const filtered = this.cyclopedias.filter((cyclopedia) => cyclopedia.id === this.currentCyclopediaId);
    //   if (filtered.length <= 0) return;
    //
    //   this.currentCyclopediaId = filtered[0].id;
    // },
    watch: {
      cyclopedias: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal) || this.currentCyclopediaId !== null) return;
        if (newVal.length <= 0) return;

        this.currentCyclopediaId = newVal[0].id;
      },
    },
    computed: {
      allAnalyses() {
        let analyses = [];
        this.cyclopedias.forEach((cyclopedia) => analyses = analyses.concat(cyclopedia.analyses))
        return analyses;
      }
    },
    methods: {
      safeCall(obj, key, fallback) {
        if (typeof obj !== 'object') return fallback;
        if (!Object.prototype.hasOwnProperty.call(obj, key)) return fallback;
        return obj[key];
      },
      /**
       *
       * @param {types.Cyclopedia} cyclopedia
       * @returns {string}
       */
      companiesString(cyclopedia){
        const tooMany = cyclopedia.companies.length > 2;
        let companiesString = '(';
          companiesString += cyclopedia.companies.slice(0, 2).map((it) => it.name).join(', ');
        if (tooMany) {
          companiesString += `, +${cyclopedia.companies.length - 2} more`;
        }
        companiesString += ')';
        return companiesString;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
